import React, {useEffect, useMemo} from "react";
import GraphicUtils from "../../../../../utils/graphic-utils.js";

export default function ReportContent({ data, collapsed }) {
    const hourlyFlowChart = useMemo(() => {
        const source = data?.hourlyFlow;

        if (!source || Array.isArray(source)) {
            return { keys: [], dataColumns: [] };
        }

        const keys = Object.keys(source);
        return {
            keys,
            dataColumns: [
                ["Fluxo veicular por hora na rota", ...keys.map((key) => Number(source[key]) || 0)]
            ]
        };
    },[data]);

    const hourlyAverageTimeChart = useMemo(() => {
        const source = data?.hourlyAverageTime;

        if (!source || Array.isArray(source)) {
            return { keys: [], dataColumns: [] };
        }

        const keys = Object.keys(source);
        return {
            keys,
            dataColumns: [
                ["Tempo médio na rota", ...keys.map((key) => Number(source[key]) || 0)]
            ]
        };
    }, [data]);

    const dailyFlowChart = useMemo(() => {
        const source = data?.dailyFlow;

        if (!Array.isArray(source)) {
            return { keys: [], dataColumns: [] };
        }

        return {
            keys: source.map((item) => item.dia_rotulo),
            dataColumns: [
                ["Fluxo veicular por dia", ...source.map((item) => Number(item.qtdT) || 0)]
            ]
        };
    }, [data]);

    const weeklyFlowChart = useMemo(() => {
        const source = data?.weeklyFlow;

        if (!Array.isArray(source)) {
            return { keys: [], dataColumns: [] };
        }

        return {
            keys: source.map((item) => item.dia_nome),
            dataColumns: [
                ["Fluxo veicular por dia da semana", ...source.map((item) => Number(item.qtdT) || 0)]
            ]
        };
    }, [data]);


    useEffect(() => {
        GraphicUtils.lineChart(
            "hourly-flow",
            hourlyFlowChart.dataColumns,
            hourlyFlowChart.keys,
            "Intervalo de horas",
            "Quantidade de veículos",
            false,
            999,
        );

        GraphicUtils.lineChart(
            "hourly-average-time",
            hourlyAverageTimeChart.dataColumns,
            hourlyAverageTimeChart.keys,
            "Intervalo de horas",
            "Tempo em minutos",
            false,
            999,
        );

        GraphicUtils.lineChart(
            "daily-flow",
            dailyFlowChart.dataColumns,
            dailyFlowChart.keys,
            "Intervalo de dias",
            "Quantidade de passagens",
            false,
            999,
        );

        GraphicUtils.lineChart(
            "weekly-flow",
            weeklyFlowChart.dataColumns,
            weeklyFlowChart.keys,
            "Dias da semana",
            "Quantidade de passagens",
            false,
        );
    }, [hourlyFlowChart, hourlyAverageTimeChart, dailyFlowChart, weeklyFlowChart, collapsed]);

    return (
        <div className="space-y-6">
            <div className="grid grid-cols-3 gap-2">
                <div className="mb-1 mt-3">
                    <div className="text-center">
                        <div className="box boxCount">
                            <h3>Total de veículos</h3>
                            <h2>{data?.vehiclesTotal ?? 0}</h2>
                        </div>
                    </div>
                </div>
                <div className="mb-1 mt-3">
                    <div className="text-center">
                        <div className="box boxCount">
                            <h3>Fluxo médio/dia</h3>
                            <h2>{data?.middleFlowDay ?? 0}</h2>
                        </div>
                    </div>
                </div>
                <div className="mb-1 mt-3">
                    <div className="text-center">
                        <div className="box boxCount">
                            <h3>Tempo médio</h3>
                            <h2>{data?.averageTime ?? 0} min.</h2>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div>
                    <span className="chart-title">Fluxo veicular por intervalo de hora</span>
                    <div id="hourly-flow" className="mt-2" title="Fluxo veicular por intervalo de hora" />
                </div>
                <div className="chart-divisor"></div>

                <div>
                    <span className="chart-title">Tempo médio na rota por intervalo de hora</span>
                    <div id="hourly-average-time" className="mt-2" title="Tempo médio na rota por intervalo de hora" />
                </div>
                <div className="chart-divisor"></div>

                <div>
                    <span className="chart-title">Fluxo veicular por dia</span>
                    <div id="daily-flow" className="mt-2" title="Fluxo veicular por dia" />
                </div>
                <div className="chart-divisor"></div>

                <div>
                    <span className="chart-title">Fluxo veicular por dia da semana</span>
                    <div id="weekly-flow" className="mt-2" title="Fluxo veicular por dia da semana" />
                </div>
                <div className="chart-divisor"></div>
            </div>
        </div>
    );
}